import {t} from 'i18next'
import {Field} from 'react-final-form'

import ButtonIcon from '../../../../../../Components/Common/Buttons/ButtonIcon'
import {ImageInput} from '../../../../../../Components/Common/Inputs/ImageInput/ImageInput'
import {useMeasurementImage} from './useMeasurementImage'

export const MeasurementImage = () => {
  const {
    handleImageUpload,
    initialImage,
    imageKey,
    isNewImage,
    renderImageUrl,
    handleDeleteImageClick
  } = useMeasurementImage()

  return (
    <>
      <div className="my-3">
        <Field name="measuresSection.measurementImage">
          {({input}) => {
            return (
              <ImageInput
                {...input}
                key={imageKey}
                value={input.value || undefined}
                label={t('MEASUREMENT_INFO')}
                placeholder={t('NO_FILE_CHOSEN')}
                onChange={value => handleImageUpload(value, input.onChange)}
                name="Measurements"
                id="Upload measurement Image"
              />
            )
          }}
        </Field>
      </div>
      <div className="w-100 d-flex justify-content-center align-items-center overflow-hidden">
        {(initialImage || isNewImage) && (
          <div className="position-relative">
            <img
              src={renderImageUrl()}
              alt="Uploaded measurement"
              className="w-100 measurement-image"
            />
            <div className="position-absolute pos-top-right-10">
              <ButtonIcon
                icon="trash"
                size={[21, 21]}
                type="secondary"
                onClick={handleDeleteImageClick}
                color="red"
              />
            </div>
          </div>
        )}
      </div>
    </>
  )
}
